import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse } from '../responses/Action';
import { TipoServicoService } from './Service';

/**
 * 
 * @param {Objeto completo contendo a lista de Vinculo Transporte} tipoServicoObject 
 */
export const getTiposServicosResponse = tipoServicoObject => ({
    type: ActionType.GET_TIPO_SERVICO_RESPONSE,
    tipoServicoObject
});


export function getTiposServicosAction() {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let tipoServicoObject = await TipoServicoService.getTiposServicos()
            dispatch(getTiposServicosResponse(tipoServicoObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}